import React, { useState, useEffect } from "react";
import { axiosInstance } from '../../Config/axios';

import { Col, Row, Form, Input, Button, Upload, DatePicker, Card, Avatar, notification, Tooltip, Typography, Collapse, Skeleton } from "antd";
import { UploadOutlined, UserOutlined, CheckOutlined, CloseOutlined  } from "@ant-design/icons";

import { updatePhotoProfile, updateDataProfile, updatePassword } from "../../API/profile"
import { handleOpenFile } from '../../API/utils';

import PageTitle from "../Common/PageTitle/PageTitle";
import "./UserProfile.css";

const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Panel } = Collapse;

const UserProfile = () => {
  const [api, contextHolder] = notification.useNotification();

  const [formPersonal] = Form.useForm();
  const [formSecurity] = Form.useForm();
  const [formGlobalDateFilter] = Form.useForm();
  //
  const [userInitials, setUserInitials] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [loading, setLoading] = useState(true);
  // Informacion del usuario
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('userData'));
    setUser(storedUser);
  }, []);

  useEffect(() => {
    if (user?.first_name && user?.last_name) {
      setUserInitials(user.first_name[0] + user.last_name[0]);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      (async () => {
        setLoading(true);

        let fullPhotoUrl = null;

        if (user.photo_url) {
          fullPhotoUrl = await handleOpenFile(user.photo_url, 'image');
        }

        formPersonal.setFieldsValue({
          area: user.area.name,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          username: user.username,
          photo_url: fullPhotoUrl,
        });

        if (fullPhotoUrl) {
          setProfileImage(fullPhotoUrl);
        }

        setLoading(false);
      })();
    }
  }, [user]);

  /* useEffect(() => {
    if (user) {
      (async () => {

        let fullPhotoUrl = null;

        if (user.photo_url) {
          fullPhotoUrl = await handleOpenFile(user.photo_url, 'image');
        }

        formPersonal.setFieldsValue({
          area: user.area.name,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          username: user.username,
        });

        setProfileImage(fullPhotoUrl);
      })();
    }
  }, [user, formPersonal]); */

  // CARD INFORMACION PERSONAL: IMAGEN DE PERFIL
  /* const handleUpload = async (info) => {
    const file = info.file.originFileObj;
    
    // Vista previa local temporal
    const objectUrl = URL.createObjectURL(file);
    setProfileImage(objectUrl);

    const formData = new FormData();
    formData.append('photo', file);

    let newPhotoUrl = null;

    try {
      const data = await updatePhotoProfile(formData);
      console.log("Foto subida:", data);

      // Limpiar la URL temporal primero
      URL.revokeObjectURL(objectUrl);

      // Construir la nueva URL asegurándonos de no tener dobles barras
       if (data.photo) {
        newPhotoUrl = await handleOpenFile(user.photo, 'image');
        console.log("newPhotoUrl", newPhotoUrl);
      }

      // Actualizar el estado y localStorage
      const updatedUser = { ...user, photo: data.photo };
      setUser(updatedUser);
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      
      // Actualizar la imagen mostrada con la URL completa del servidor
      setProfileImage(newPhotoUrl);
      api.success({ message: "Imagen de perfil actualizada correctamente."});
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error subiendo la imagen:", error);
    }
  }; */
  
  const handleUpload = async (info) => {
    const file = info.file.originFileObj;

    // Vista previa local temporal
    const objectUrl = URL.createObjectURL(file);
    setProfileImage(objectUrl);

    const formData = new FormData();
    formData.append('photo', file);

    try {
      const data = await updatePhotoProfile(formData);

      // Limpiar la URL temporal
      URL.revokeObjectURL(objectUrl);

      const serverPhotoPath = data.photo; 

      if (!serverPhotoPath) {
        throw new Error("No se recibió la ruta de la imagen del servidor");
      }

      // Generar URL blob para mostrar
      const newPhotoUrl = await handleOpenFile(serverPhotoPath, 'image');

      const updatedUser = { 
        ...user, 
        photo_url: serverPhotoPath  
      };
      
      // Guardar en estado y localStorage
      setUser(updatedUser);
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      setProfileImage(newPhotoUrl);
      
      api.success({ 
        message: "Imagen de perfil actualizada correctamente." 
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      
      if (user?.photo_url) {
        const oldPhotoUrl = await handleOpenFile(user.photo_url, 'image');
        setProfileImage(oldPhotoUrl);
      } else {
        setProfileImage(null);
      }
      
      api.error({ 
        message: "Error subiendo la imagen", 
        description: error.message 
      });
    }
  };

  const validateBeforeUpload = (file) => {
    const isValidType = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
    const isValidSize = file.size / 1024 / 1024 < 2;

    if (!isValidType) {
      api.error({
        message: "Formato inválido",
        description: "Solo se permiten imágenes en formato PNG, JPG o JPEG.",
      });
      return Upload.LIST_IGNORE;
    }

    if (!isValidSize) {
      api.error({
        message: "Archivo demasiado grande",
        description: "La imagen no debe superar los 2 MB.",
      });
      return Upload.LIST_IGNORE;
    }

    handleUpload({ file: { originFileObj: file } });
    return false;
  };

  // CARD INFORMACIÓN PERSONAL: DATOS
  /* const handleSavePersonal = async (values) => {
    const dataToSend = {
      ...values, 
    };

    console.log(dataToSend)

    try {
      console.log("Enviando datos al servidor:", dataToSend);
      
      const response = await updateDataProfile(dataToSend);
      console.log("Respuesta del servidor:", response);

      // Actualizar el estado local y localStorage si es necesario
      const updatedUser = { ...user, ...dataToSend };
      setUser(updatedUser);
      localStorage.setItem('userData', JSON.stringify(updatedUser));

      notification.success({
        message: 'Perfil actualizado',
        description: 'Tus datos se han actualizado correctamente'
      });

    } catch (error) {
      console.error("Error al actualizar perfil:", error);
      
      notification.error({
        message: 'Error',
        description: 'No se pudo actualizar el perfil. Por favor intenta nuevamente.'
      });
    }
  }; */
  
  {/* CARD SEGURIDAD */}
  const [passwordRules, setPasswordRules] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const validatePasswordRules = (password) => {
    setPasswordRules({
      length: password.length >= 8 && password.length <= 20,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const RuleCheck = ({ text, checked }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: 13,
        fontWeight: 600,
        color: checked ? "#4ED500" : "grey",
      }}
    >
      {checked ? <CheckOutlined /> : <CloseOutlined />} &nbsp;{text}
    </div>
  );

  const handleSaveSecurity = async (values) => {
    try {
      const response = await updatePassword(values);
      console.log("Contraseña actualizada:", response);
      api.success({ message: 'Contraseña actualizada correctamente' });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
   } catch (error) {
      const backendErrors = error?.response?.data;

      let errorMessage = 'No se pudo actualizar tu contraseña. Intenta nuevamente.';

      if (backendErrors?.old_password?.includes("La contraseña actual no es correcta.")) {
        errorMessage = 'La contraseña actual que ingresaste no es correcta.';
      }

      else if (backendErrors?.new_password?.length) {
        const newPassError = backendErrors.new_password[0];

        if (newPassError.includes("últimas 10 contraseñas")) {
          errorMessage = "No puedes usar una de tus últimas 10 contraseñas.";
        } else if (newPassError.includes("too similar to the email")) {
          errorMessage = "La nueva contraseña es similar a tu correo electrónico.";
        } else if (newPassError.includes("too similar to the first name")) {
          errorMessage = "La nueva contraseña es similar a tu nombre.";
        } else if (newPassError.includes("too similar to the last name")) {
          errorMessage = "La nueva contraseña es similar a tu apellido.";
        } else if (newPassError.includes("too similar to the username")) {
          errorMessage = "La nueva contraseña es similar a tu nombre de usuario.";
        } else {
          errorMessage = newPassError;
        }
      }

      api.error({
        message: 'Error al actualizar',
        description: errorMessage,
        key: 'save-password-error'
      });
    }
  };

  // CARD FILTRO
  /* const handleGlobalDateFilter = (values) => {
    if (values.dateRange) {
      const formattedDates = values.dateRange.map(date => date.format("DD/MM/YYYY"));
      console.log("Filtro global:", formattedDates);
    }
  }; */

  return (
    <>
      {contextHolder}
      <Row justify="start">
        <Col>
          <PageTitle title="Perfil del Usuario" icon="userprofile" />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Card className="userprofile-card" /* title="Información Personal" */>
            <Skeleton loading={loading} avatar active paragraph={{ rows: 4 }}>
              <Row gutter={16} align="middle">
                <Col
                  span={8}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Upload
                    showUploadList={false}
                    beforeUpload={validateBeforeUpload}
                  >
                    <Tooltip title={profileImage ? "Cambiar imagen de perfil" : "Subir imagen de perfil"}>
                      <Avatar
                        className={`profile-avatar upload-avatar ${!profileImage ? 'profile-initials' : ''}`}
                        size={100}
                        src={profileImage}
                      >
                        {!profileImage && userInitials}
                      </Avatar>
                    </Tooltip>
                  </Upload>

                  <Text type="secondary" style={{ fontSize: 12, textAlign: "center" }}>
                    Adjunte una foto de perfil no mayor a 2 MB <br /> en formato PNG, JPG o JPEG.
                  </Text>
                </Col>

                <Col span={16}>
                  <Form form={formPersonal} layout="vertical" /* onFinish={handleSavePersonal} */>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item name="first_name" label="Nombre" /* rules={[{ required: true, message: "Ingrese su nombre" }]} */> 
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="last_name" label="Apellido" /* rules={[{ required: true, message: "Ingrese su apellido" }]} */> 
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item name="email" label="Email" /* rules={[{ required: true, message: "Ingrese su email", type: "email" }]} */> 
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="username" label="Usuario" /* rules={[{ required: true, message: "Ingrese su nombre de usuario" }]} */> 
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="area" label="Area"> 
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    {/* <Row justify="end">
                      <Button type="primary" htmlType="submit">Guardar Datos</Button>
                    </Row> */}
                  </Form>
                </Col>
              </Row>
            </Skeleton>
          </Card>

          <Collapse defaultActiveKey={[]} className="custom-collapse">
            <Panel header="Cambiar Contraseña" key="1">
              <Card className="userprofile-card" bodyStyle={{ padding: 0 }}>
                <Form form={formSecurity} layout="vertical" onFinish={handleSaveSecurity}>
                  <Row gutter={24} style={{ margin: 0 }}>
                    {/* COLUMNA IZQUIERDA: Inputs */}
                    <Col xs={24} md={12} className="password-inputs-box">
                      <Form.Item
                        name="old_password"
                        label="Contraseña Actual"
                        rules={[{ required: true, message: "Ingrese su contraseña actual" }]}
                      >
                        <Input.Password onChange={(e) => setOldPassword(e.target.value)} />
                      </Form.Item>

                      <Form.Item
                        name="new_password"
                        label="Nueva Contraseña"
                        rules={[
                          { required: true, message: "Ingrese su nueva contraseña" },
                          () => ({
                            validator(_, value) {
                              if (!value) return Promise.resolve();
                              const validations = {
                                length: value.length >= 8 && value.length <= 20,
                                uppercase: /[A-Z]/.test(value),
                                lowercase: /[a-z]/.test(value),
                                number: /[0-9]/.test(value),
                                special: /[!@#$%^&*(),.?":{}|<>]/.test(value),
                              };
                              const allValid = Object.values(validations).every(Boolean);
                              if (!allValid) {
                                return Promise.reject(
                                  new Error("La contraseña no cumple con todos los requisitos de seguridad")
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            validatePasswordRules(e.target.value);
                          }}
                        />
                      </Form.Item>

                      <Form.Item
                        name="new_password_confirm"
                        label="Repite Nueva Contraseña"
                        dependencies={["new_password"]}
                        hasFeedback
                        rules={[
                          { required: true, message: "Confirme su nueva contraseña" },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || newPassword === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error("Las contraseñas no coinciden"));
                            },
                          }),
                        ]}
                      >
                        <Input.Password onChange={(e) => setNewPasswordConfirm(e.target.value)} />
                      </Form.Item>

                      <Row justify="end">
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={
                            !(
                              oldPassword &&
                              Object.values(passwordRules).every(Boolean) &&
                              newPassword &&
                              newPasswordConfirm &&
                              newPassword === newPasswordConfirm
                            )
                          }
                        >
                          Actualizar Contraseña
                        </Button>
                      </Row>
                    </Col>

                    {/* COLUMNA DERECHA: Validaciones */}
                    <Col xs={24} md={12} className="password-rules-box">
                      <h4>La contraseña debe tener:</h4>
                      <RuleCheck text="Tener entre 8 y 20 caracteres" checked={passwordRules.length} />
                      <RuleCheck text="Incluir al menos una letra mayúscula" checked={passwordRules.uppercase} />
                      <RuleCheck text="Incluir al menos una letra minúscula" checked={passwordRules.lowercase} />
                      <RuleCheck text="Incluir al menos un número" checked={passwordRules.number} />
                      <RuleCheck text="Incluir al menos un caracter especial" checked={passwordRules.special} />
                    </Col>
                  </Row>
                </Form>
              </Card>
              </Panel>
            </Collapse>
          </Col>

        {/* <Col span={12}>
          <Card className="settings-card" title="Filtro de Fechas Global">
            <Form form={formGlobalDateFilter} layout="vertical" onFinish={handleGlobalDateFilter}>
              <Form.Item 
                name="dateRange"
                label="Seleccionar Rango de Fechas"
                //rules={[{ required: true, message: "Seleccione un rango de fechas" }]}
              >
                <RangePicker 
                  placeholder={["Fecha de inicio", "Fecha de fin"]} 
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode} />
              </Form.Item>
              <Row justify="end">
                <Button type="primary" htmlType="submit">Aplicar Filtro</Button>
              </Row>
            </Form>
          </Card>
        </Col> */}

      </Row>
      </>
  );
};

export default UserProfile;